/**
 * Конвертирует строку в число, возвращая null для пустых строк
 * @param value - строковое значение
 * @returns число или null
 */
export function stringToNumber(value: string): number | null {
  const numericString = value.replace(/[^\d]/g, '');
  if (numericString === '') {
    return null;
  }
  const number = Number(numericString);

  return isNaN(number) || !isFinite(number) ? null : number;
}
